import { render, staticRenderFns } from "./DeviceOnboarding.vue?vue&type=template&id=6df2e81a&lang=pug"
import script from "./DeviceOnboarding.vue?vue&type=script&lang=js"
export * from "./DeviceOnboarding.vue?vue&type=script&lang=js"
import style0 from "./DeviceOnboarding.vue?vue&type=style&index=0&id=6df2e81a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports